import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ImageOff, ArrowLeft } from 'lucide-react'
import { getServices } from '../api/services'
import styles from './Services.module.css'

function Services() {
  const [services, setServices] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getServices()
      .then(setServices)
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  return (
    <main className={styles.page}>
      <Link to="/" className={styles.homeBtn}>
        <ArrowLeft size={14} />Back to Home
      </Link>
      <h1 className={styles.heading}>Our Services</h1>
      <p className={styles.subtitle}>Here's what we can do for you.</p>

      {loading ? (
        <p className={styles.loading}>Loading…</p>
      ) : services.length === 0 ? (
        <p className={styles.empty}>No services available yet.</p>
      ) : (
        <div className={styles.grid}>
          {services.map((s) => (
            <div key={s.id} className={styles.card}>
              {s.thumbnail ? (
                <img src={s.thumbnail} alt={s.name} className={styles.thumbnail} />
              ) : (
                <div className={styles.thumbnailPlaceholder}>
                  <ImageOff size={32} />
                </div>
              )}
              <div className={styles.info}>
                <p className={styles.name}>{s.name}</p>
                {s.description && (
                  <p className={styles.description}>{s.description}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </main>
  )
}

export default Services
